import * as Yup from 'yup';

const passwordRules = Yup.string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
  .matches(/[a-z]/, 'Must contain at least one lowercase letter')
  .matches(/[0-9]/, 'Must contain at least one number')
  .matches(/[!@#$%^&*(),.?":{}|<>_\-+=]/, 'Must contain at least one special character')
  .required('Password is required');

export const athleteSignupSchema = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: passwordRules,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Please confirm your password'),
  profilePhoto: Yup.string().url('Invalid profile photo URL').nullable(),
});

export const coachSignupSchema = Yup.object({
  firstName: Yup.string()
    .required('First name is required'),
  lastName: Yup.string()
    .required('Last name is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
  organization: Yup.string()
    .optional(),
  profilePhoto: Yup.string()
    .url('Invalid profile photo URL')
    .nullable(),
});
